module.exports = __webpack_public_path__ + "assets/image-file-svg.4c9599a6.svg";